import { ChangeDetectionStrategy, Component, HostBinding, Input, input } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
    selector: 'app-common-header',
    templateUrl: './common-header.component.html',
    styleUrls: ['./common-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SvgIconComponent]
})
export class CommonHeaderComponent {
  readonly icon = input<string>();
  @Input() @HostBinding('class.logoIconWhite') isLogoIconWhite = false;
  @Input() @HostBinding('class.logoIconBlue') isLogoIconBlue = false;


}
